module.exports = __webpack_public_path__ + "img/flower.11f09baf.png";